import styled, { css } from 'styled-components';
import { Colors, Media, TextStylesDesktop, TextStylesMobile } from 'enums';

type ILinkProps = {
  withIcon?: boolean;
  withAlternativeIcon?: boolean;
};

export const LinkWrapStyled = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const LinkStyled = styled.a<ILinkProps>`
  color: ${({ color }) => color};
  border-bottom: 1px solid ${Colors.yellow1};
  text-decoration: none;
  padding-bottom: 2px;
  display: inline-block;
  ${TextStylesMobile.body}

  @media ${Media.notebook} {
    ${TextStylesDesktop.body}
  }

  &:active {
    color: ${Colors.yellow1};
  }

  ${(props) =>
    props.withIcon &&
    css`
      margin-left: 6px;

      @media ${Media.notebook} {
        margin-left: 2px;
      }
    `}

  ${(props) =>
    props.withAlternativeIcon &&
    css`
      margin-left: 6px;

      @media ${Media.notebook} {
        margin-left: 10px;
      }
    `}
`;
